import dayjs from "dayjs";
import { useEffect, useState } from "react";
import calculateChange from "../../../functions/Common/calculateChange";
import useGetMerchantId from "../../../functions/Merchant/getMerchantId";
import useGetNewInvoiceNo from "../../../functions/Transaction/getNewInvoiceNo";
import Receipt from "./Receipt";

export default function CreditCard(props) {
  const {
    plates,
    onPaymentSuccessReset,
    receiptPrice,
    setReceiptPrice,
    transactionInfo,
    setTransactionInfo,
    setExtraChargesOptions,
  } = props;

  // These hooks will re-run whenever `receiptPrice` changes.
  const { merchantId } = useGetMerchantId(receiptPrice);
  const { invoiceNo } = useGetNewInvoiceNo(receiptPrice);

  const [
    isDisableCompleteTransactionButton,
    setIsDisableCompleteTransactionButton,
  ] = useState(true);

  useEffect(() => {
    const tempReceiptPrice = {
      ...receiptPrice,
      cash: receiptPrice.total,
    };

    const amountCalculated = calculateChange(tempReceiptPrice);

    setReceiptPrice((prev) => ({
      ...prev,
      cash: prev.total,
      total: amountCalculated.total,
      change: amountCalculated.change,
      round_adj: amountCalculated.round_adj,
    }));
  }, []);

  useEffect(() => {
    if (!invoiceNo || !merchantId) return;

    setTransactionInfo({
      invoice_no: invoiceNo,
      payment_id: null,
      amount: receiptPrice.total,
      sst_amount: receiptPrice.sst,
      subtotal: receiptPrice.subtotal,
      transaction_datetime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      payment_method: "Credit Card",
      status: 1,
      merchant_id: merchantId,
      pg_transaction_id: null,
      signature: null,
      err_desc: null,
      pay_amount: receiptPrice.total,
      change_amount: receiptPrice.change,
      round_adj_amount: receiptPrice.round_adj,
      takeaway_fee: receiptPrice.takeaway_fee,
    });

    setIsDisableCompleteTransactionButton(false);
  }, [invoiceNo, merchantId]);

  return (
    <Receipt
      plates={plates}
      onPaymentSuccessReset={onPaymentSuccessReset}
      transactionInfo={transactionInfo}
      setTransactionInfo={setTransactionInfo}
      isDisableCompleteTransactionButton={isDisableCompleteTransactionButton}
      setExtraChargesOptions={setExtraChargesOptions}
    />
  );
}
